/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */
const DEBUG_BUILD = (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__);

export { DEBUG_BUILD };
//# sourceMappingURL=debug-build.js.map



// WEBPACK FOOTER //
// ./~/@sentry/vue/esm/debug-build.js